'use strict';

var typography = require('../../../../../../../../_virtual/typography.cjs');

const TYPOGRAPHY_TYPES = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    body: "body",
    footnote: "footnote",
    caption: "caption",
    subcaption: "subcaption"
};

typography.__exports.TYPOGRAPHY_TYPES = TYPOGRAPHY_TYPES;

module.exports = typography.__exports;
//# sourceMappingURL=typography.cjs.map
